import { Component, ElementRef, ViewChild } from '@angular/core';

import { TooltipDirective } from 'ngx-bootstrap/tooltip';

import { ClipboardService } from 'src/app/shared/services/clipboard.service';
import { OutsideClickService } from 'src/app/shared/services/outside-click.service';

@Component({
  selector: 'share-url-button',
  templateUrl: './share-url-button.component.html',
  styleUrls: ['./share-url-button.component.scss'],
  standalone: false,
})
export class ShareUrlButtonComponent {
  @ViewChild('tooltipTrigger') tooltipTrigger: ElementRef;

  constructor(
    private clipboardService: ClipboardService,
    private outsideClickService: OutsideClickService,
  ) {}

  getUrl() {
    return window.location.href;
  }

  copyToClipboard(text: string): void {
    this.clipboardService.copy(text);
    this.toggleTooltip();
  }

  onTextFocus(event) {
    event.target.select();
  }

  showPopover() {
    this.outsideClickService.bind(
      'share-url-popover',
      '#share-url-popover, #share-url-button',
      this.toggleTooltip.bind(this),
    );
  }

  hidePopover() {
    this.outsideClickService.unbind('share-url-popover');
  }

  toggleTooltip() {
    (this.tooltipTrigger as unknown as TooltipDirective).toggle();
  }
}
